// GlobalStyle.js
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');

  body {
    font-family: 'Montserrat', sans-serif;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  /* Ant Design Typography */
  .ant-typography,
  .ant-typography h1, 
  .ant-typography h2, 
  .ant-typography h3, 
  .ant-typography h4, 
  .ant-typography h5, 
  .ant-typography p, 
  .ant-typography span {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Buttons */
  .ant-btn {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Input Fields */
  .ant-input {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Select */
  .ant-select-selector {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Modal */
  .ant-modal {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Table */
  .ant-table, 
  .ant-table-thead > tr > th, 
  .ant-table-tbody > tr > td {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Form */
  .ant-form-item-label > label,
  .ant-form-item-control-input {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Dropdown */
  .ant-dropdown-menu {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Menu */
  .ant-menu-item,
  .ant-menu-submenu-title {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Tabs */
  .ant-tabs-tab {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Popover */
  .ant-popover-inner-content {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Pagination */
  .ant-pagination-item,
  .ant-pagination-item-link {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Alert */
  .ant-alert-message,
  .ant-alert-description {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Badge */
  .ant-badge-count {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Card */
  .ant-card {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Tooltip */
  .ant-tooltip-inner {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Notification */
  .ant-notification-notice-message,
  .ant-notification-notice-description {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Breadcrumb */
  .ant-breadcrumb-link {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Drawer */
  .ant-drawer-title,
  .ant-drawer-body {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Steps */
  .ant-steps-item-title {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Badge */
  .ant-badge-count {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Collapse */
  .ant-collapse-header {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Progress */
  .ant-progress-text {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Calendar */
  .ant-picker-calendar-full .ant-picker-panel {
    font-family: 'Montserrat', sans-serif !important;
  }

  /* Ant Design Sider */
  .ant-layout-sider h3, .ant-layout-sider p {
    font-family: 'Montserrat', sans-serif !important;
  }
`;
  

export default GlobalStyle;